import React, { useMemo, useState } from "react";

import { ProgressBarConfig } from "@intelligems/ig-types";

import { ProgressBarContext } from "./ProgressBarContext";

interface ProgressBarContextProviderProps {
  config?: ProgressBarConfig;
  mode: "toggle" | "input";
  children?: React.ReactNode;
}

export const ProgressBarContextProvider = ({
  config,
  mode,
  children,
}: ProgressBarContextProviderProps) => {
  const breakpoints = config?.desktop.breakpoints ?? [];
  const breakpoint = breakpoints[breakpoints.length - 1];
  const threshold = breakpoint?.value || 1;
  const [fraction, setFraction] = useState(0.66);
  const [aboveThreshold, setAboveThreshold] = useState(false);

  const context = useMemo(() => {
    const cartValue =
      mode === "toggle"
        ? fromAboveThreshold(threshold, aboveThreshold)
        : fromFraction(threshold, fraction);
    const setCartValue = (cartValue: number) => {
      setFraction(toFraction(threshold, cartValue));
    };

    return {
      unitType: config?.unitType ?? "unit",
      mode,
      cartValue,
      setCartValue,
      aboveThreshold,
      setAboveThreshold,
    };
  }, [
    config?.unitType,
    mode,
    aboveThreshold,
    setAboveThreshold,
    fraction,
    setFraction,
  ]);
  return (
    <ProgressBarContext.Provider value={context}>
      {children}
    </ProgressBarContext.Provider>
  );
};

function fromAboveThreshold(threshold: number, aboveThreshold: boolean) {
  if (aboveThreshold) {
    return threshold;
  } else {
    let value = Math.round(0.66 * threshold);
    if (value === threshold) {
      value--;
    }
    return value;
  }
}

function fromFraction(threshold: number, fraction: number) {
  return Math.round(fraction * threshold);
}

function toFraction(threshold: number, cartValue: number) {
  return cartValue / threshold;
}
